import { View } from "binder"
import { ProductionOrder, ProductionOrderManipulationViewModel } from "./productionOrderManipulation-viewModel"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";

export class ProductionOrderManipulationView extends View<ProductionOrderManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-04618037-352E-4C96-AD0D-7B1D50D08A11"
    }
    loadHtml(): string {
        let element = require('./productionOrderManipulation.html').default;
        let style = require('./productionOrderManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionOrders(v: ProductionOrder) { this._productionOrders = v; } public get productionOrders(): ProductionOrder { return this._productionOrders; } private _productionOrders: ProductionOrder;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
